import { useBrowseSubscriptionPlanApi } from '@aibees/shared/api';
import { PlanInterval } from '@aibees/shared/definition';
import { useEffect } from 'react';

export function usePlanList(yearly: boolean) {
  const interval = yearly ? PlanInterval.YEAR : PlanInterval.MONTH;
  const { data, refetch, isLoading } = useBrowseSubscriptionPlanApi(interval);
  const { data: mounthPlans } = useBrowseSubscriptionPlanApi(
    PlanInterval.MONTH
  );

  const freePlan = mounthPlans?.find((plan) => plan.amount === 0);

  useEffect(() => {
    refetch();
  }, [yearly]);

  return { plans: data, freePlan, isLoading };
}
